import React, { useLayoutEffect } from "react";
import styled from "styled-components";

const NewMagazineContainer = styled.div`
    width: 100%;
    margin: 30px auto;
    padding: 30px;
    text-align: center;
    background-color: ${({ theme }) => theme.colors.white};

    iframe {
        width: 100%;
        max-width: 400px;
        max-height: 300px;
        border: none;
        padding-top: 0;
    }

    a {
        max-height: 350px;
        padding: 20px 0;

        button.icon-book-next.stripe-btn {
            display: none !important;
        }
    }

    h4 {
        margin: 15px;
    }

    @media screen and (max-width: 830px) {
        iframe {
            min-height: 300px;
            max-height: 350px;
        }
    }
`;

const NewMagazineFlippingBook = (props) => {
    useLayoutEffect(() => {
        const script = document.createElement("script");
        script.src =
            "https://api.semantika.pl/public-assets/flippingbook/Magazyn-Zdrowe-Dziecko/files/html/static/embed.js";
        script.async = true;

        document.querySelector("#root").appendChild(script);
    }, []);

    return (
        <NewMagazineContainer id="nowy_numer">
            <h2>Wydanie: LATO, nr 1 (1) 2021</h2>
            <h4>Czytaj online</h4>
            <iframe
                width="1200"
                height="500"
                title="Flipping book Nowy numer"
                src="https://api.semantika.pl/public-assets/flippingbook/Magazyn-Zdrowe-Dziecko/index.html"
                allowFullScreen
            ></iframe>
        </NewMagazineContainer>
    );
};
export default NewMagazineFlippingBook;
